'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = collectWords;

var _createWalker = require('./create-walker');

var _createWalker2 = _interopRequireDefault(_createWalker);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var FULL_NUMBERS = /^\d+$/g;
var SPECIAL_JA = '？ ！「。」（）、 ～©■※：';
var SPECIAL_ASCII = '\\s!"#$%&\'()*+,\\-./:;<>=?@\\[\\]^_`{|}~.?';
var HIRAGANA = "\\u3040-\\u309F";
var KATAKANA = "\\u30A0-\\u30FF";
var KANJI = "\\u4E00-\\u9FD5";
var SPECIAL_CHARS = new RegExp('[' + SPECIAL_ASCII + SPECIAL_JA + HIRAGANA + KATAKANA + KANJI + ']+', 'g');

function collectWords(node) {
  var words = {};
  var walker = (0, _createWalker2["default"])(node);

  while (walker.nextNode()) {
    var newWords = walker.currentNode.wholeText.split(/\b/);
    newWords.map(strip).filter(function (word) {
      return !!word;
    }).forEach(function (word) {
      words[word] = true;
    });
  }

  return words;
}

function strip(word) {
  return word.toLowerCase().replace(SPECIAL_CHARS, '').replace(FULL_NUMBERS, '');
}